import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import reportWebVitals from './reportWebVitals';

import { ConfirmProvider } from 'react-confirm-hook';
import { Provider } from 'react-redux';
import { ThemeProvider } from './lib/Theme';
import { registerServiceWorker } from './lib/notifications';



function importBuildTarget() { 
    const DEFAULT_APP = 'SKYSPYKE'
    
    let buildTarget = process.env.REACT_APP_BUILD_TARGET;
    if (buildTarget === undefined)
        buildTarget = DEFAULT_APP;

    if (buildTarget === 'SKYSPYKE') {
        return import('./apps/skyspyke/App');
    }
    else if (buildTarget === 'C2') {
        return import('./apps/c2/App')
    }
    else {
        return Promise.reject(
            new Error("No such build target: " + buildTarget)
        ); 
    }
} 


importBuildTarget().then(({ default: Environment, store }) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <ThemeProvider>
                    <ConfirmProvider>
                        <Environment />
                    </ConfirmProvider>
                </ThemeProvider>
            </Provider>
        </React.StrictMode>
    );
});

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        registerServiceWorker();
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
